"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTextBlock", {
  enumerable: true,
  get: function get() {
    return _SVBTextBlock.default;
  }
});
var _SVBTextBlock = _interopRequireDefault(require("./src/SVBTextBlock"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }